import * as actions from './ProjectedBalanceSheetActions'

const initialState = {
    YearOptions: []
}

const blankClientItem = {
    PrincipalAgeOptions: [],
    SpouseAgeOptions: [],
    ProjectedItems: [],
    is_initialized: false,
    errors: [],
    owners: [],
    error_type: null,
}

const ProjectedBalanceSheet = (state = initialState, action) => {
    switch (action.type) {
        case actions.RECEIVE_DATA:
            return Object.assign({}, state, {
                YearOptions: action.resp_data.YearOptions,
                [action.clientId]: {
                    ...blankClientItem,
                    ...state[action.clientId],
                    PrincipalAgeOptions: action.resp_data.PrincipalAgeOptions,
                    SpouseAgeOptions: action.resp_data.SpouseAgeOptions,
                    PrincipalName: action.resp_data.PrincipalName,
                    SpouseName: action.resp_data.SpouseName,
                    ProjectedItems: action.resp_data.BalanceSheet,
                    Periods: action.resp_data.Periods,
                    Milestones: action.resp_data.Milestones,
                    is_initialized: true,
                    errors: [],
                    error_type: null,
                }
            })
        case actions.SET_ERRORS:
            return Object.assign({}, state, {
                [action.clientId]: {
                    ...state[action.clientId],
                    errors: action.errors
                }
            })
        case actions.SET_ERROR_TYPE:
            return Object.assign({}, state, {
                [action.clientId]: {
                    ...state[action.clientId],
                    error_type: action.error_type
                }
            })
        case actions.SET_YEAR:
            return Object.assign({}, state, {
                [action.clientId]: {
                    ...state[action.clientId],
                    year: action.year
                }
            })
        case actions.SET_CURRENT:
            return Object.assign({}, state, {
                [action.clientId]: {
                    ...state[action.clientId],
                    is_current: action.is_current
                }
            })
        default:
            return state
    }
}

export default ProjectedBalanceSheet
